import { useBrand } from '../shared/components/BrandContext.js';
import { KordaroLogo } from '../shared/components/KordaroLogo.js';

/**
 * Logo in de lichte schil: exact Kordaro-SVG (primair, op ivoor) of het goedgekeurde winkellogo.
 * Winkel zonder logo maar met eigen naam → de naam als tekst (Kordaro wordt nooit herkleurd).
 */
export function MerkLogo({ breedte = 160 }: { breedte?: number }) {
  const brand = useBrand();
  if (brand.toontPlatformMerk) return <KordaroLogo variant="primary" width={breedte} />;
  if (brand.logoUrl) {
    return <img src={brand.logoUrl} alt={brand.naam} className="max-h-10 w-auto object-contain" style={{ maxWidth: breedte }} />;
  }
  return <span className="text-lg leading-7 font-semibold text-gray-900 truncate">{brand.naam}</span>;
}
